import React, { useState } from "react";
import "./EditProfile.css";

const EditProfile = () => {
  const [formData, setFormData] = useState({
    name: " ",
    email: "john.doe@example.com",
    phone: "",
    address: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Profile updated successfully!");
    // Add logic to update profile in your backend or state
  };

  return (
    <div className="edit-profile-container">
      <h1>EDIT PROFILE</h1>
      <form onSubmit={handleSubmit} className="edit-profile-form">
        <label>
          Name
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </label>
        <label>
          Email
          <input
            type="email"
            name="email"
            value={formData.email}
            readOnly // Make email uneditable
          />
        </label>
        <label>
          Phone
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </label>
        <label>
          Address
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
          ></textarea>
        </label>
        <button type="submit" className="edit-profile-button">UPDATE</button>
      </form>
    </div>
  );
};

export default EditProfile;
